/**
 * @flow
 * */

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  GalleryThumbnailImageContainer,
  GalleryThumbnailImage,
  selectedThumbnail
} from './styledComponents'

class ThumbnailImage extends Component {
  static propTypes = {
    currentGalleryItem: PropTypes.object,
    currentIndex: PropTypes.number,
    selectedIndex: PropTypes.number,
    onPress: PropTypes.func
  }

  onPress = () => {
    const { currentIndex, onPress } = this.props
    onPress(currentIndex)
  }

  render() {
    const { currentGalleryItem, currentIndex, selectedIndex, id } = this.props
    const { galleryThumbnailUrl, galleryImageAltText } = currentGalleryItem
    return (
      <GalleryThumbnailImageContainer>
        <GalleryThumbnailImage
          className={currentIndex === selectedIndex ? selectedThumbnail : null}
          src={galleryThumbnailUrl}
          onClick={this.onPress}
          alt={galleryImageAltText}
          draggable={false}
          id={id}
        />
      </GalleryThumbnailImageContainer>
    )
  }
}

export default ThumbnailImage



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ArcadeGallery/ThumbnailImage/index.js